import { MutableRefObject, useEffect, useRef } from 'react';

/**
 * Tracks whether the component is still mounted. useAsync does not cancel the
 * request it starts, so callers check this before logging a rejection that
 * would otherwise land after teardown.
 */
export const useMountedFlag = (): MutableRefObject<boolean> => {
  const active = useRef(true);
  useEffect(() => {
    // Re-arm for StrictMode, which runs cleanup and then the effect again on the same instance.
    active.current = true;
    return () => {
      active.current = false;
    };
  }, []);
  return active;
};
